import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { C } from "@/data/content";
import Reveal, { SectionHeader } from "@/components/Reveal";

export default function Process() {
    const { L } = useLanguage();

    return (
        <section id="process" className="py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6">
                <SectionHeader
                    eyebrow={L(C.process.eyebrow)}
                    title={L(C.process.title)}
                    align="center"
                />

                <div className="relative mt-16 grid gap-12 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
                    <motion.span
                        initial={{ scaleX: 0 }}
                        whileInView={{ scaleX: 1 }}
                        viewport={{ once: true, amount: 0.4 }}
                        transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                        className="absolute top-7 hidden h-px w-full origin-center bg-gradient-to-r from-transparent via-brass/60 to-transparent lg:block"
                    />

                    {C.process.steps.map((step, i) => (
                        <Reveal key={i} delay={0.1 * i} data-testid={`process-step-${i + 1}`}>
                            <div className="relative">
                                <span className="font-mono-x relative z-10 grid size-14 place-items-center rounded-full border border-gold-line-strong bg-ink text-sm text-brass">
                                    {step.num}
                                </span>
                                <h3 className="font-display mt-6 text-xl font-bold text-txt-1">
                                    {L(step.title)}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-txt-2">
                                    {L(step.desc)}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
